export default __webpack_public_path__ + "static/media/colors.fd6ca94a.png";